export const SET_GSC_BALANCE = 'SET_GSC_BALANCE';
export const SET_ANDES_ERROR_MERCHANT_BALANCE = 'SET_ANDES_ERROR_MERCHANT_BALANCE';
export const SET_ANDES_ERROR_MERCHANT_AVAILABLE = 'SET_ANDES_ERROR_MERCHANT_AVAILABLE';
export const SET_MERCHANT_AVAILABLE = 'SET_MERCHANT_AVAILABLE';
export const SET_TOTAL_BALANCE = 'ANDES/SET_TOTAL_BALANCE';
export const SET_ADVANCEABLE_INCOME = 'SET_ADVANCEABLE_INCOME';
export const SET_MERCHANT_BALANCE = 'SET_MERCHANT_BALANCE';
export const FETCH_ANDES_BALANCE = 'FETCH_ANDES_BALANCE';
export const SET_ANDES_ERROR_GSC = 'SET_ANDES_ERROR_GSC';
export const SET_ANDES_ERROR_MERCHANT = 'SET_ANDES_ERROR_MERCHANT';
export const SET_ALL_BALANCE = 'SET_ALL_BALANCE';
export const SET_ANDES_ERROR_ALL_BALANCE = 'SET_ANDES_ERROR_ALL_BALANCE';
export const SET_LOADED_AMOUNT = 'ANDES/SET_LOADED_AMOUNT';
export const SET_AMOUNT_WITHRAW = 'SET_AMOUNT_WITHRAW';
